import { create } from 'zustand';

import { IPolicyModalState } from './interfaces';

const initialState = {
  open: false,
  viewOnly: false,
  pdfContent: [],
};

export const usePolicyState = create<IPolicyModalState>((set) => ({
  ...initialState,
  // Closing always leaves view-only mode so it never leaks into the next open.
  setOpen: (open) => set(open ? { open } : { open, viewOnly: false }),
  setViewOnly: (viewOnly: boolean) => set({ viewOnly }),
  setPdfContent: (pdfContent: string[]) => set({ pdfContent }),
}));
